import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgxSkeletonLoaderModule } from 'ngx-skeleton-loader';
import { CommonModule } from '@angular/common';
import { NgxRandomModule } from 'ngx-random';
import { AccountRoutingModule } from './account-routing.module';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { AccountLoginModule, DisplayErrorModule, DisplayValidationErrorsModule } from '@unleashed/common/components';
import {
  AccountInfoComponent,
  AccountInfoFormComponent,
  LoginSignupComponent,
  ProvisionalAccountFlowComponent,
  ReservationsComponent,
  SignupFormComponent
} from '@unleashed/account/components';
import { PipesModule } from '@unleashed/common/pipes/pipes.module';

@NgModule({
  declarations: [
    AccountInfoComponent,
    AccountInfoFormComponent,
    SignupFormComponent,
    LoginSignupComponent,
    ProvisionalAccountFlowComponent,
    ReservationsComponent
  ],
  exports: [
    LoginSignupComponent
  ],
  imports: [
    CommonModule,
    AccountRoutingModule,
    DisplayValidationErrorsModule,
    FontAwesomeModule,
    FormsModule,
    ReactiveFormsModule,
    NgxSkeletonLoaderModule,
    NgxRandomModule,
    PipesModule,
    AccountLoginModule,
    DisplayErrorModule
  ]
})
export class AccountModule {
}
